import { useEffect, useRef } from 'react';
import { debounce } from 'lodash';

import { RouterSelectors, useRedux } from '@zapier/toolbox-redux-framework';

import { Account, Profile } from '@zapier/shared-entities';

const excludedRoutes = ['/app/editor', '/app/login'];

const mapStateToProps = state => {
  const url = RouterSelectors.getCurrentPathname(state);
  const isExcludedRoute = !excludedRoutes.some(route => url.startsWith(route));
  return {
    shouldRender: Profile.selectors.all.isLoggedIn(state) && !isExcludedRoute,
    url,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    reloadAccountLimits() {
      dispatch(Account.actions.reloadCurrentAccount());
    },
  };
};

/**
 * This component watches for changes in the current URL and fires an account
 * limits reload whenever they occur.
 */
function UrlBasedAccountLimitReloader() {
  const { reloadAccountLimits, shouldRender, url } = useRedux(
    mapStateToProps,
    mapDispatchToProps
  );

  // Only allow to reload once every 10 seconds max
  const reload = useRef(
    debounce(
      reloadAccountLimits,
      10 * 1000, // 10 seconds
      { leading: true }
    )
  );

  useEffect(() => {
    if (shouldRender) {
      reload.current();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url]);

  return null;
}

export default UrlBasedAccountLimitReloader;
